import type { SxProps, Theme } from '@mui/material/styles';

type MainLayoutStyleMap = {
    root: SxProps<Theme>
    appBar: SxProps<Theme>
    toolbar: SxProps<Theme>
    logoLink: SxProps<Theme>
    logoIcon: SxProps<Theme>
    desktopNav: SxProps<Theme>
    authActions: SxProps<Theme>
    mainContent: SxProps<Theme>
    footer: SxProps<Theme>
    footerGrid: SxProps<Theme>
    footerBrand: SxProps<Theme>
    footerBrandIcon: SxProps<Theme>
    footerLink: SxProps<Theme>
    footerBottom: SxProps<Theme>
};

export const mainLayoutStyles: MainLayoutStyleMap = {
    root: { minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'grey.50' },
    appBar: { bgcolor: 'background.paper', color: 'text.primary', boxShadow: 1 },
    toolbar: { justifyContent: 'space-between', height: 64 },
    logoLink: { display: 'flex', alignItems: 'center', textDecoration: 'none' },
    logoIcon: { width: 32, height: 32, bgcolor: 'primary.main', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 },
    desktopNav: { display: { xs: 'none', md: 'flex' }, gap: 1 },
    authActions: { display: 'flex', gap: 1 },
    mainContent: { flexGrow: 1 },
    footer: { bgcolor: 'grey.900', color: 'common.white', py: 6, mt: 'auto' },
    footerGrid: { display: 'grid', gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr' }, gap: 4 },
    footerBrand: { display: 'flex', alignItems: 'center', mb: 2 },
    footerBrandIcon: { width: 32, height: 32, bgcolor: 'primary.dark', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 },
    footerLink: { color: 'inherit', textDecoration: 'none', '&:hover': { color: 'common.white' } },
    footerBottom: { mt: 6, pt: 3, borderTop: '1px solid', borderColor: 'grey.800', textAlign: 'center' },
};

export const getMainLayoutNavLinkStyles = (isActive: boolean): SxProps<Theme> => ({
    color: isActive ? 'primary.main' : 'text.secondary',
    fontWeight: isActive ? 700 : 400,
});
